export default __webpack_public_path__ + "static/media/rabbit_type_1_3.ab8bcc69.svg";